import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import VueGtag from "vue-gtag";

Vue.use(VueRouter)
Vue.use(VueGtag, {
  config: { id: "UA-102839764-3" }
});
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: true,
    children: [
      {
        path: '1',
        component: () => import('@/views/questions/companyType.vue')
      },
      {
        path: '12',
        component: () => import('@/views/questions/companyDetail.vue')
      },
      {
        path: '2',
        component: () => import('@/views/questions/industry.vue')
      },
      {
        path: '3',
        component: () => import('@/views/questions/turnover.vue')
      },
      {
        path: '4',
        component: () => import('@/views/questions/yearsTrading.vue')
      },
      {
        path: '5',
        component: () => import('@/views/questions/expectedCustomers.vue')
      },
      {
        path: 'recap',
        component: () => import('@/views/applicationPages/recap.vue')
      },
      {
        path: 'edit/:fieldType',
        component: () => import('@/views/applicationPages/edit.vue'),
        props: true
      },
      {
        path: 'decide',
        component: () => import('@/views/applicationPages/decide.vue')
      },
      {
        path: 'contact',
        component: () => import('@/views/applicationPages/contact.vue')
      },
      {
        path: 'submitquote',
        component: () => import('@/views/applicationPages/submitQuote.vue')
      },
      {
        path: '*',
        component: () => import('@/views/applicationPages/startPage.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to) => {
  let ga = router.app.__proto__.$gtag
  let path = to.fullPath
  if (process.env.VUE_APP_MODE !== 'production') {
    path = '/staging/' + path
  }
  ga.pageview({
    page_path: path
  })
})

export default router
